var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2479 2C6.30929 2.36618 2.36618 6.30929 2 11.2479H3.97778C4.39314 11.2479 4.72986 11.5846 4.72986 12C4.72986 12.4154 4.39314 12.7521 3.97778 12.7521H2C2.36618 17.6907 6.30929 21.6338 11.2479 22V20.0222C11.2479 19.6069 11.5846 19.2701 12 19.2701C12.4154 19.2701 12.7521 19.6069 12.7521 20.0222V22C17.6907 21.6338 21.6338 17.6907 22 12.7521H20.0222C19.6069 12.7521 19.2701 12.4154 19.2701 12C19.2701 11.5846 19.6069 11.2479 20.0222 11.2479H22C21.6338 6.30929 17.6907 2.36618 12.7521 2V3.97778C12.7521 4.39314 12.4154 4.72986 12 4.72986C11.5846 4.72986 11.2479 4.39314 11.2479 3.97778V2ZM12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11ZM9 12H15C15.5523 12 16 12.4477 16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 12.4477 8.44772 12 9 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetCustomer);
export default __webpack_public_path__ + "static/media/target-customer.01c4b4c984723e998cd0195b4a71ee71.svg";
export { ForwardRef as ReactComponent };